import { Icon, Menu, TopBar, TopBarProfileButton } from '@nordlayer/rivendell-ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Header = function Header(_ref) {
    var currentAccount = _ref.currentAccount;
    var fullName = (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.name) || '';
    return /*#__PURE__*/ _jsx(TopBar, {
        children: /*#__PURE__*/ _jsxs(Menu, {
            children: [/*#__PURE__*/ _jsx(TopBarProfileButton, {
                    fullName: fullName,
                    userRole: null
                }), /*#__PURE__*/ _jsx(Menu.Popover, {
                    placement: "bottom",
                    children: /*#__PURE__*/ _jsx(Menu.Content, {
                        children: /*#__PURE__*/ _jsxs(Menu.Item, {
                            href: "/logout",
                            children: [/*#__PURE__*/ _jsx(Icon, {
                                    name: "logout16"
                                }), "Log out"]
                        })
                    })
                })]
        })
    });
};
